
import { RootState, useAppDispatch, useAppSelector } from "../store";
import {
    toggleTheme as toggleThemeAction,
} from '../slices/themeSlice';

// Not every component needs to dispatch actions individually; therefore, we create a common hook to handle dispatching.
export const useUpdateTheme = () => {
  const dispatch = useAppDispatch();
  function toggleTheme() {
      dispatch(toggleThemeAction());
  }


  return {
    toggleTheme,
  };
};

// custom hook for accessing the data
export const useTheme= () => {
  return {
    theme: useAppSelector((state: RootState):any => {
      return state.themeObject.theme;
    }),
    themeValue:useAppSelector((state: RootState):any => {
        return state.themeObject.themeValue;
      }),
  }
 
};